import assetCategoryService from "../../../../services/assetService/assetCategoryService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETCATEGORIES } from "../../../../utils/constants";
import { AssetCategoryInterface } from "../../../../models/AssetModel/AssetCategory";

const useAssetCategories = (page: number, pageSize: number) =>
  useQuery<AssetCategoryInterface[], Error>({
    queryKey: [
      CACHE_KEY_ASSETCATEGORIES,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => assetCategoryService.GetAll(page, pageSize),
  });

export default useAssetCategories;
